/**
 * Quick Start documentation page — step-by-step setup guide.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { quickstartContent } from "@/constants/docs/quickstart";

export const Route = createFileRoute("/docs/quickstart")({
	component: QuickStartPage,
});

function QuickStartPage() {
	return <DocsPage title="Quick Start" content={quickstartContent} />;
}
